module.exports = __webpack_public_path__ + "img/nt-back.2b9bdcf9.png";